import React from "react";
import { useSelector } from "react-redux";
import { Attachment } from "@mui/icons-material";
import { ListItemIcon, MenuItem } from "@mui/material";

import AttachmentModal from "fond/attachments/AttachmentModal";
import { getCurrentProject } from "fond/project/redux";
import { PermissionLevel, Store } from "fond/types";
import { Actions, permissionCheck } from "fond/utils/permissions";

import { trackPageMenuItemClick } from "../helper";

interface IProps {
  permissionLevel: PermissionLevel;
  handleClose: () => void;
}

const Files: React.FC<IProps> = ({ permissionLevel, handleClose }: IProps) => {
  const [isAttachmentModalOpen, setAttachmentModalOpen] = React.useState<boolean>(false);
  const canViewAttachments = permissionCheck(permissionLevel, Actions.PROJECT_VIEW_ATTACHMENT);
  const project = useSelector((state: Store) => getCurrentProject(state.project));

  /**
   * Handles opening the Project Attachments modal
   */
  const handleAttachments = () => {
    if (canViewAttachments) {
      setAttachmentModalOpen(true);
    }
    handleClose();
    trackPageMenuItemClick("project", "files", project);
  };

  const onModalClose = () => {
    setAttachmentModalOpen(false);
  };

  return (
    <>
      <MenuItem data-testid="files-button" onClick={handleAttachments} disabled={!canViewAttachments}>
        <ListItemIcon>
          <Attachment />
        </ListItemIcon>
        Files
      </MenuItem>
      {isAttachmentModalOpen && <AttachmentModal onClose={onModalClose} isOpen />}
    </>
  );
};

export default Files;
